import * as style from '../utils/general_style';
import * as nous from '../components/quisommesnous/export';
import CTAButton from '../components/global/CTAButton';
import icon1 from '../assets/icons-1.png';
import icon2 from '../assets/icons-5.png';
import icon3 from '../assets/icons-6.png';
import img1 from '../assets/G1_2.jpg';

function QuiSommesNous() {
    const engagements = [
        {
            img: icon1,
            alt: 'icone informatique',
            text: <p>&#9656; Solutions 100% numérisées</p>
        }, {
            img: icon2,
            alt: 'icone partenaire',
            text: <p>&#9656; Saisie du support facilité</p>
        }, {
            img: icon3,
            alt: 'icone chronomètre rapide',
            text: <p>&#9656; Réactivité et adaptabilité</p>
        }
    ];

	return (
        <div className="AppBody">
            <section style={style.ELEMENT_BLOCK_GREY}>
                <h1 style={{marginBottom: style.SPACE.large}}>Qui sommes-nous ?</h1>
                <article style={{...style.ROW_SPACE_BETWEEN, paddingBottom: style.SPACE.medium}}>
                    <div className="paragraph" style={{...style.COLUMN_CENTER, width: '55%'}}>
                        <p><span style={style.PRESENTIS}>Presentis</span> est une plateforme de service mettant en relation les assureurs, les experts et les bureaux d'études avec nos entreprises partenaires spécialisées dans les investigations et la réparation après sinistre.</p>
                        <p>Une équipe dédiée reste à votre disposition pour un échange simplifié et une écoute efficace en cas de besoin.</p>
                        <p><span style={style.PRESENTIS}>Presentis</span> intervient dans toute la France et apporte une rapidité et une qualité de service à votre projet.</p>
                    </div>
                    <div style={{width: '42%'}}>
                        <img src={img1} alt={'homme utilisant une machine'} />
                    </div>
                </article>
                <article style={style.ROW_CENTER}>
                    <CTAButton />
                </article>
            </section>
            <section style={style.ELEMENT_BLOCK_WHITE}>
                <h2>Nos engagements</h2>
                <article style={style.ROW_SPACE_AROUND}>
                    {engagements.map(({img, alt, text}, index) => (
                        <nous.Engagements icon={ img } alt={ alt } text={ text } key={ index } />
                    ))}
                </article>
            </section>
            <section style={style.ELEMENT_BLOCK_GREY}>
                <h2>En quelques chiffres</h2>
                <nous.QuelquesChiffres />
            </section>
            <section style={style.ELEMENT_BLOCK_WHITE}>
                <h2>Nos investigations d'étude de sol réalisées</h2>
                <nous.CarteFrance />
            </section>
        </div>
	);
};

export default QuiSommesNous;